import { css } from 'emotion';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const containerRules = css({
    cursor: 'ppinter',
    minWidth: 290,
    height: 270,
    overflow: 'scroll',
    '@media(min-width: 300px)': {
      minWidth: 324
    }
  });

  export const yearItemRules = (isCurrentYear: boolean) =>
    css({
      fontSize: isCurrentYear ? '1.8rem' : undefined,
      fontWeight: isCurrentYear ? 600 : 500,
      cursor: !isCurrentYear ? 'pointer' : undefined,
      transition: animationTransition('font-size', 'font-weight'),
      height: 42,
      letterSpacing: '.288px',
      lineHeight: '42px',
      textAlign: 'center',
      ' span': {
        pointerEvents: 'none'
      }
    });
}
